import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducer/root-reducer';

export const sagaMiddleware = createSagaMiddleware();
export let appState = null;

export default function configStore(initialState = {}) {
	appState = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));
	return appState;
}
